import { CheckoutOptions, CheckoutResponse, AcimaLauncher, ClientOptions, PreapprovalOptions, PrequalOptions, ApplicationStatusResponse } from "src/launcher";
import { baseUrl, manifestUrl } from "./config/config";


declare global {
  interface Window {
    __ACIMA_ASSET_MANIFEST__: Record<string, string>
  }
}


interface PreapprovalCommand {
  method: "preapproval"
  arguments: PreapprovalOptions,
  res: (value: ApplicationStatusResponse | PromiseLike<ApplicationStatusResponse | null> | null) => void
  rej: (reason?: any) => void
}

interface CheckoutCommand {
  method: "checkout",
  arguments: CheckoutOptions,
  res: (value: CheckoutResponse | PromiseLike<CheckoutResponse>) => void
  rej: (reason?: any) => void
}

interface PrequalCommand {
  method: "prequal",
  arguments: PrequalOptions,
  res: (value: ApplicationStatusResponse | PromiseLike<ApplicationStatusResponse>) => void,
  rej: (reason?: any) => void
}

type ClientCommand = PreapprovalCommand | CheckoutCommand | PrequalCommand

export class Client {

  private queue: ClientCommand[] = []
  private config: ClientOptions
  private acima: AcimaLauncher

  preapproval(opts: PreapprovalOptions): Promise<ApplicationStatusResponse | null> {
    if (this.acima) {
      return this.acima.preapproval(opts)
    }
    return new Promise((res, rej) => {
      this.queue.unshift({ method: "preapproval", arguments: opts, res, rej })
    })
  }

  checkout(opts: CheckoutOptions): Promise<CheckoutResponse> {
    if (this.acima) {
      return this.acima.checkout(opts)
    }
    return new Promise((res, rej) => {
      this.queue.unshift({ method: "checkout", arguments: opts, res, rej })
    })
  }

  prequal(opts: PrequalOptions): Promise<ApplicationStatusResponse> {
    if (this.acima) {
      return this.acima.prequal(opts)
    }
    return new Promise((res, rej) => {
      this.queue.unshift({ method: "prequal", arguments: opts, res, rej })
    })
  }

  closeIframe() {
    if (this.acima) {
      return this.acima.closeIframe()
    }
  }

  private onLoad = () => {
    this.acima = new AcimaLib.AcimaLauncher(this.config);
    this.queue.forEach((item) => {
      switch (item.method) {
        case "preapproval":
          return this.acima[item.method](item.arguments)
            .then(item.res)
            .catch(item.rej);
        case "checkout":
          return this.acima[item.method](item.arguments)
            .then(item.res)
            .catch(item.rej);
        case "prequal":
          return this.acima[item.method](item.arguments)
            .then(item.res)
            .catch(item.rej);
      }
    })
  }

  constructor(config: ClientOptions) {
    this.config = config
    const manifestScript = document.createElement('script')
    manifestScript.src = `${manifestUrl}?t=${Date.now()}`
    document.head.appendChild(manifestScript)
    
    manifestScript.addEventListener('load', () => {
      const manifest = window.__ACIMA_ASSET_MANIFEST__
       if (!manifest['acimaLauncher.js']) {
          console.error('manifest does not contain acimaLauncher.js')
        }
        const acimaScript = document.createElement('script')
        acimaScript.src = `${baseUrl}/${manifest['acimaLauncher.js']}`;
        document.head.appendChild(acimaScript) 
        acimaScript.addEventListener('load', this.onLoad);

    })

    manifestScript.addEventListener('error', function (e) {
      console.error('Acima manifest failed to load', e);
    });
  }
}